module.exports = __webpack_public_path__ + "static/media/CheckmarkWithoutCircle.7481c457.svg";